import { render, staticRenderFns } from "./PublicationBrowser.vue?vue&type=template&id=20e1ec2f&scoped=true"
import script from "./PublicationBrowser.vue?vue&type=script&lang=js"
export * from "./PublicationBrowser.vue?vue&type=script&lang=js"
import style0 from "./PublicationBrowser.vue?vue&type=style&index=0&id=20e1ec2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1ec2f",
  null
  
)

export default component.exports